import type { ReactNode } from "react";

export const isRenderableNode = (node: ReactNode): boolean =>
  node !== null && node !== undefined && typeof node !== "boolean" && node !== "";

export const getNonEmptyString = (value: unknown): string | undefined =>
  typeof value === "string" && value.length > 0 ? value : undefined;

export const isNonEmptyString = (value: unknown): boolean =>
  typeof value === "string" && value.trim().length > 0;

// 문단(`Text` 의 p·span)에 담아도 되는 글자인가. 요소 노드는 div·button 을 품을 수 있어 문단 안에
// 두면 HTML 이 깨진다(`<div>` 는 `<p>` 의 자손이 될 수 없다).
export const isTextNode = (node: ReactNode): node is string | number =>
  typeof node === "string" || typeof node === "number";
